module.exports = __webpack_public_path__ + "static/media/3.efd862a0.png";